
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.less';
import { applyTheme } from './theme';

const params = new URLSearchParams(window.location.search);

// Extract functional params before passing the rest to theming
const currency = params.get('currency') ?? undefined;
const currencyOptions = params.get('currencyOptions') ?? undefined;
const partner = params.get('partner') ?? undefined;
const email = params.get('email') ?? undefined;
const locale = params.get('locale') ?? undefined;
const amount = params.get('amount') ?? undefined;
const focusAmount = params.has('focusAmount');
const hidePoweredBy = params.has('hidePoweredBy');
const showTitle = params.has('title');
const scale = params.get('scale') ?? undefined;

// Collect ref and utm_* params to forward to the submit URL
const forwardParams: Record<string, string> = {};
for (const [key, value] of params.entries()) {
  if (key === 'ref' || key.startsWith('utm_')) {
    forwardParams[key] = value;
  }
}

params.delete('currency');
params.delete('currencyOptions');
params.delete('partner');
params.delete('email');
params.delete('locale');
params.delete('amount');
params.delete('focusAmount');
params.delete('hidePoweredBy');
params.delete('title');
params.delete('scale');
for (const key of Object.keys(forwardParams)) {
  params.delete(key);
}

applyTheme(params);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App
      currency={currency}
      currencyOptions={currencyOptions}
      partner={partner}
      email={email}
      forwardParams={forwardParams}
      locale={locale}
      amount={amount}
      focusAmount={focusAmount}
      hidePoweredBy={hidePoweredBy}
      showTitle={showTitle}
      scale={scale}
    />
  </React.StrictMode>
);

